module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/en/5-f396ffa83df54f4c6842fdc464c400e6.jpg";